import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import Checkbox from '../../../ui/Checkbox';
import { deleteRallyResults } from '../../../api/admin/results';
import { setRallyResultsWasDeleted } from '../../../store/adminSlices/rallies';
import Loader from '../../../ui/Loader';
import { useNavigate } from 'react-router-dom';
import { generateIdRoutePath } from '../../../helpers';
import { APP_ROUTES } from '../../../app.config.vars/routes';
import ConfirmDeleteAction from '../confirmDeleteAction';
const ConfirmDeleteRallyStatistic = ({ rallyId, resultsAmount, }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [isConfirm, setIsConfirm] = useState(false);
    const [deleteRallyStatus, setDeleteRallyStatus] = useState(null);
    const deleteRallyStatistic = async () => {
        try {
            setDeleteRallyStatus('pending');
            await deleteRallyResults(rallyId);
            dispatch(setRallyResultsWasDeleted(true));
            setDeleteRallyStatus('success');
        }
        catch (error) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    return (_jsxs(ConfirmDeleteAction, { children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t(deleteRallyStatus === 'pending'
                        ? 'admin.deleting_rally_results'
                        : deleteRallyStatus === 'success'
                            ? 'admin.rally_results_were_deleted'
                            : 'admin.delete_rally_statistic'), type: 'h1' }) }), _jsx("div", { className: "modal-content-description", children: deleteRallyStatus === 'pending' ? (_jsx(Loader, {})) : deleteRallyStatus === 'success' ? null : (_jsxs(_Fragment, { children: [_jsx("p", { children: t('admin.number_of_results_to_delete', { resultsAmount }) }), _jsx("p", { children: t('admin.irreversible_action') })] })) }), _jsx("div", { className: "modal-content-checkbox", children: deleteRallyStatus !== 'pending' && deleteRallyStatus !== 'success' && (_jsx(Checkbox, { id: 'delete-rally-statistic-confirmation', label: t('label.confirm_delete_rally_results'), checked: isConfirm, onChange: () => setIsConfirm((prev) => !prev), labelColor: '#000' })) }), _jsx("div", { className: `modal-content-button${deleteRallyStatus === 'success' ? '' : ' not-deleted'}`, children: _jsxs(ButtonsGroup, { justify: 'center', children: [deleteRallyStatus === 'success' ? (_jsx(Button, { label: t('button.ok'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            } })) : (_jsx(Button, { label: t('button.cancel'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            }, disabled: deleteRallyStatus === 'pending' })), deleteRallyStatus === 'success' ? (_jsx(Button, { variant: 'outlined', label: t('button.edit_rally'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                                navigate(generateIdRoutePath(APP_ROUTES.adminManageTasks, rallyId));
                            } })) : (_jsx(Button, { variant: 'outlined', label: t('button.delete_rally_statistic'), onClick: deleteRallyStatistic, disabled: deleteRallyStatus === 'pending' || !isConfirm }))] }) })] }));
};
export default ConfirmDeleteRallyStatistic;
